<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h5>{{ $t('menu.lottoTickets') }}</h5>
                <div class="p-grid">
                    <div class="p-col-12 p-md-2" v-show="!isRedirect">
                        <span class="p-float-label">
                            <Calendar ref="startDateCalendar" style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="startDateModel"></Calendar>
                            <label>{{ $t('sportsbets.startDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2" v-show="!isRedirect">
                        <span class="p-float-label">
                            <Calendar style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="endDateModel"></Calendar>
                            <label>{{ $t('sportsbets.endDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2" v-show="!isRedirect">
                        <span class="p-float-label">
                            <Dropdown :showClear="true" style="width: 100%" v-model="shopsModel" :options="shops" optionLabel="name" :filter="!this.isMobile()" />
                            <label>{{ $t('dropdown.placeholder.shop') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Dropdown :showClear="true" style="width: 100%" v-model="statusModel" :options="ticketStatuses" optionLabel="name" :filter="!this.isMobile()" />
                            <label>{{ $t('dropdown.placeholder.status') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Dropdown :showClear="true" style="width: 100%" v-model="lotteryModel" :options="lotteries" optionLabel="name" :filter="!this.isMobile()" />
                            <label>{{ $t('dropdown.placeholder.lottery') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2" v-show="!isRedirect">
                        <span class="p-float-label">
                            <Dropdown :showClear="true" style="width: 100%" v-model="payShopsModel" :options="shops" optionLabel="name" :filter="!this.isMobile()" />
                            <label>{{ $t('dropdown.placeholder.payShop') }}</label>
                        </span>
                    </div>
                    <div class="p-col-6 p-text-left p-grid" v-show="!isRedirect">
                        <p class="p-mt-2 p-ml-2">{{ $t('bets.dateFilterFooter') }}</p>
                        <div class="p-col-12 p-md-2">
                            <div class="p-field-radiobutton">
                                <RadioButton id="option3" name="option" :value="toggleOptions[0].value" v-model="useCreateDateToggle" />
                                <label for="option3">{{ toggleOptions[0].label }}</label>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-2">
                            <div class="p-field-radiobutton">
                                <RadioButton id="option3" name="option" :value="toggleOptions[1].value" v-model="useCreateDateToggle" />
                                <label for="option3">{{ toggleOptions[1].label }}</label>
                            </div>
                        </div>
                    </div>
                    <div v-if="isRedirect" class="p-col-8 p-text-right"><Button :label="$t('buttons.back')" class="p-button-raised p-button-info" @click="goto(backRoute)" /></div>

                    <div v-else class="p-col-6 p-text-right"><Button :label="$t('buttons.getData')" class="p-button-raised p-button-success" @click="applyFiltersOnly()" /></div>
                </div>
                <Fieldset v-show="!isRedirect" :legend="$t('search.byId')" :toggleable="true" :collapsed="true" class="p-col-12 p-mb-2">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-2">
                            <span class="p-float-label">
                                <InputText style="width: 100%" type="text" v-model="ticketSerial" />
                                <label>{{ $t('bets.ticketSerial') }}</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-md-2 p-text-right"><Button :label="$t('buttons.searchData')" class="p-button-raised p-button-warning" @click="applySerialOnly()" /></div>
                    </div>
                </Fieldset>
                <Fieldset v-show="!isRedirect" :legend="$t('search.byDrawid')" :toggleable="true" :collapsed="true" class="p-col-12 p-mb-2">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-2">
                            <span class="p-float-label">
                                <InputText style="width: 100%" type="text" v-model="selectedDrawId" />
                                <label>{{ $t('lotto.drawId') }}</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-md-2 p-text-right"><Button :label="$t('buttons.searchData')" class="p-button-raised p-button-warning" @click="applyDrawOnly()" /></div>
                    </div>
                </Fieldset>
                <DataTable
                    :lazy="true"
                    :value="items"
                    :paginator="true"
                    :rows="perPage"
                    :loading="loading"
                    class="p-mt-3"
                    :totalRecords="totalPages"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                    ref="datatable"
                    responsiveLayout="scroll"
                    :paginatorBottom="true"
                    v-model:expandedRows="expandedRows"
                >
                    <Column
                        ><template #body="slotProps">
                            <span class="indexColumn">{{ (this.crtPage - 1) * this.perPage + slotProps.index + 1 }}</span>
                        </template>
                    </Column>
                    <Column :expander="true" headerStyle="width: 3rem" />
                    <Column :header="$t('general.status')">
                        <template #body="{ data }">
                            <Button :label="$t('bets.status.' + getTicketStatusName(data.Status))" :class="'p-button-outlined p-mr-2 p-mb-2 p-button-' + getTicketStatusColor(data.Status) + ' p-mr-2'" />
                        </template>
                    </Column>
                    <Column>
                        <template #body="{ data }"> <i :title="$t('lotto.awaitsApprovalLotto')" v-if="data.StatusAvailable == false && data.Status != 2" class="pi pi-exclamation-circle" /> </template
                    ></Column>
                    <Column field="TicketSerial" :header="$t('bets.ticketSerial')" :sortable="true"></Column>
                    <Column field="TicketDate" :header="$t('bets.placeDate')" :sortable="true">
                        <template #body="{ data }"> {{ formatCSDateAndTime(data.TicketDate) }} </template>
                    </Column>
                    <Column field="ShopId" :header="$t('bets.shopName')">
                        <template #body="{ data }">{{ shopsDictionary[data.ShopId] }}</template>
                    </Column>
                    <Column field="CashierId" :header="$t('bets.cashier')">
                        <template #body="{ data }">{{ cashiersDictionary[data.CashierId] }}</template>
                    </Column>
                    <Column field="DrawName" :header="$t('lotto.lotteryName')"> </Column>
                    <Column field="DrawId" :header="$t('lotto.drawId')"> </Column>
                    <Column field="DrawDate" :header="$t('lotto.date')">
                        <template #body="{ data }">{{ formatCSDateAndTime(data.DrawDate) }}</template>
                    </Column>
                    <Column field="PlayedAmount" :header="$t('bets.playedAmount')" :sortable="true">
                        <template #body="{ data }"> {{ formatCurrency(data.PlayedAmount) }} </template>
                    </Column>
                    <Column field="StakeAmount" :header="$t('bets.stakeAmount')" :sortable="true">
                        <template #body="{ data }"> {{ formatCurrency(data.StakeAmount) }} </template>
                    </Column>
                    <Column field="TicketLinesNo" :header="$t('bets.lineNo')" :sortable="true"></Column>
                    <Column field="MaxWinAmount" :header="$t('bets.maxWinAmount')" :sortable="true">
                        <template #body="{ data }"> {{ formatCurrency(data.MaxWinAmount) }} </template>
                    </Column>
                    <Column>
                        <template #body="{ data }">
                            <Button :title="$t('bets.cashoutTitle')" v-show="data.EarlyCashoutActive" icon="pi pi-dollar" class="p-button-rounded p-button-success p-button-text p-mr-2" />
                        </template>
                    </Column>
                    <Column field="WinInfo" :header="$t('bets.winAmount')" :sortable="true">
                        <template #body="{ data }"> {{ notNullOrEmptyObject(data.WinInfo) ? formatCurrency(data.WinInfo.WinAmount) : 0 }} </template>
                    </Column>
                    <Column field="WinInfo" :header="$t('bets.winnerId')">
                        <template #body="{ data }"> {{ notNullOrEmptyObject(data.WinInfo) ? data.WinInfo.WinnerSSN : '' }} </template>
                    </Column>
                    <Column field="WinInfo" :header="$t('bets.winnerName')">
                        <template #body="{ data }"> {{ notNullOrEmptyObject(data.WinInfo) ? data.WinInfo.WinnerName : '' }} </template>
                    </Column>
                    <Column field="PayInfo" :header="$t('bets.payDate')">
                        <template #body="{ data }"> {{ notNullOrEmptyObject(data.PayInfo) ? formatCSDateAndTime(data.PayInfo.Date) : '' }} </template>
                    </Column>
                    <Column field="PayInfo" :header="$t('bets.paidBy')">
                        <template #body="{ data }"> {{ notNullOrEmptyObject(data.PayInfo) ? getPaidBy(data.PayInfo.OperatorId) : '' }} </template>
                    </Column>
                    <Column field="VoidInfo" :header="$t('bets.voidDate')">
                        <template #body="{ data }"> {{ notNullOrEmptyObject(data.VoidInfo) ? formatCSDateAndTime(data.VoidInfo.Date) : '' }} </template>
                    </Column>
                    <Column field="VoidInfo" :header="$t('bets.voidBy')">
                        <template #body="{ data }"> {{ notNullOrEmptyObject(data.VoidInfo) ? getPaidBy(data.VoidInfo.OperatorId) : '' }} </template>
                    </Column>
                    <Column>
                        <template #body="{ data }">
                            <Button :title="$t('bets.fromWebTitle')" v-show="data.FromWeb" icon="pi pi-cloud-download" class="p-button-rounded p-button-info p-button-text p-mr-2" />
                        </template>
                    </Column>
                    <Column>
                        <template #body="{ data }">
                            <Button :title="$t('bets.liveTitle')" v-show="data.ContainsLiveEvents" icon="pi pi-desktop" class="p-button-rounded p-button-info p-button-text p-mr-2" />
                        </template>
                    </Column>
                    <template #expansion="slotProps">
                        <LottoTicketDetails :ticketSerial="slotProps.data.TicketSerial"></LottoTicketDetails>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>
</template>
<script>
import { BoTicketsApi } from '../../service/BoTicketsApi';
import { BoApi } from '../../service/BoApi';
import { LottoApi } from '../../service/LottoApi';

import LottoTicketDetails from './Components/LottoTicketDetails.vue';

import settings from '../../settings/generalSettings';
import { uiSettings } from '../../settings/uiSettings';
export default {
    name: 'lottoTickets',
    components: {
        LottoTicketDetails,
    },
    data() {
        return {
            tableHeight: uiSettings.tableHeight,
            cashiersDictionary: [],
            shopsDictionary: [],
            startDateModel: null,
            endDateModel: null,
            BoTicketsApi: new BoTicketsApi(),
            BoApi: new BoApi(),
            LottoApi: new LottoApi(),
            ticketStatuses: settings.TicketStatuses,
            statusModel: { name: 'All', value: 100 },
            shops: [],
            users: [],
            items: [],
            shopsModel: { name: 'All', id: '0' },
            payShopsModel: { name: 'All', id: '0' },
            ticketType: settings.ticketType.lotto,
            sort: 'ticketDate|desc',
            crtPage: 0,
            perPage: uiSettings.tableRows,
            loading: true,
            totalPages: 0,
            ticketSerial: '',
            useCreateDateToggle: 1,
            selectedDrawId: '',
            lotteries: [],
            lotteryModel: { name: 'All', id: 0, code: 0 },
            expandedRows: [],
        };
    },
    props: {
        drawIdParam: {
            type: String,
            default: '',
        },
    },
    computed: {
        toggleOptions() {
            return [
                {
                    value: 1,
                    label: this.$t('bets.placeDate'),
                },
                {
                    value: 0,
                    label: this.$t('bets.processDate'),
                },
            ];
        },
        isRedirect() {
            return this.notNullOrEmptyField(this.ticketSerials);
        },
    },
    watch: {
        shopsModel() {
            if (!this.notNullOrEmptyObject(this.shopsModel)) {
                this.shopsModel = { name: 'All', id: '0' };
            }
        },
        statusModel() {
            if (!this.notNullOrEmptyObject(this.statusModel)) {
                this.statusModel = { name: 'All', value: 100 };
            }
        },
        lotteryModel() {
            if (!this.notNullOrEmptyObject(this.lotteryModel)) {
                this.lotteryModel = { name: 'All', id: 0, code: 0 };
            }
        },
        payShopsModel() {
            if (this.notNullOrEmptyObject(this.payShopsModel)) {
                if (this.payShopsModel.id == '0') {
                    this.statusModel = { name: 'All', value: 100 };
                } else {
                    this.statusModel = { name: 'Paid', value: 3 };
                }
            } else {
                this.statusModel = { name: 'All', value: 100 };
                this.payShopsModel = { name: 'All', id: '0' };
            }
        },
    },
    mounted() {
        let crtDate = new Date();
        let year = crtDate.getFullYear();
        let month = crtDate.getMonth() + 1;
        if (month <= 9) {
            month = '0' + month;
        }
        let day = crtDate.getDate();
        if (day <= 9) {
            day = '0' + day;
        }
        var startDateString = year + '-' + month + '-' + day + 'T00:00';
        var endDateString = year + '-' + month + '-' + day + 'T23:59';
        this.startDateModel = new Date(startDateString);
        this.endDateModel = new Date(endDateString);
        this.selectedDrawId = this.drawIdParam;
        this.getShops();
        this.getCashierUsers();
        this.getLotteriesForFilter();
        this.readItems();
    },
    methods: {
        getLotteriesForFilter() {
            this.LottoApi.getLotteriesForFilter()
                .then((response) => {
                    this.lotteries = response.data;
                })
                .catch(() => {});
        },
        getPaidBy(cashierId) {
            return cashierId != null ? this.cashiersDictionary[cashierId] : this.$t('system.terminal');
        },
        getShops() {
            this.BoApi.getShops('')
                .then((shopsResponse) => {
                    let shopsDdlValues = [];
                    for (var i = 0; i < shopsResponse.data.length; i++) {
                        let shopItem = {
                            name: shopsResponse.data[i].code + ' - ' + shopsResponse.data[i].name,
                            id: shopsResponse.data[i]._id,
                        };
                        shopsDdlValues.push(shopItem);
                    }
                    this.shops = shopsDdlValues;
                    this.createShopsDictionary();
                    this.shops.unshift(this.shopsModel);
                })
                .catch((error) => {
                    this.checkForUnauthorizedError(error);
                });
        },
        getCashierUsers() {
            this.BoApi.getAllUsers()
                .then((userResponse) => {
                    this.users = userResponse.data;
                    this.createcashiersDictionary();
                })
                .catch((error) => {
                    this.checkForUnauthorizedError(error);
                });
        },
        createShopsDictionary() {
            for (let i = 0; i < this.shops.length; i++) {
                this.shopsDictionary[this.shops[i].id] = this.shops[i].name;
            }
        },
        createcashiersDictionary() {
            for (let i = 0; i < this.users.length; i++) {
                this.cashiersDictionary[this.users[i]._id] = this.users[i].username;
            }
        },
        applyFiltersOnly() {
            this.ticketSerial = '';
            this.fixtureId = '';
            this.readItems();
        },
        applySerialOnly() {
            this.shopsModel = { name: 'All', id: '0' };
            this.statusModel = { name: 'All', value: '100' };
            this.payShopsModel = { name: 'All', id: '0' };
            this.lotteryModel = { name: 'All', id: 0, code: 0 };
            this.selectedDrawId = '';
            this.readItems();
        },
        applyDrawOnly() {
            this.shopsModel = { name: 'All', id: '0' };
            this.payShopsModel = { name: 'All', id: '0' };
            this.statusModel = { name: 'All', value: '100' };
            this.lotteryModel = { name: 'All', id: 0, code: 0 };
            this.ticketSerial = '';
            this.readItems();
        },
        onPage(event) {
            this.readItems(event.page + 1);
        },
        onSort(event) {
            let sortOrder = event.sortOrder == 1 ? 'asc' : 'desc';
            if (event.sortField == 'winInfo') {
                this.sort = 'winAmount' + '|' + sortOrder;
            } else {
                this.sort = event.sortField + '|' + sortOrder;
            }
            this.readItems();
        },
        readItems(page = 1) {
            this.crtPage = page;
            this.loading = true;

            const params = {
                per_page: this.perPage,
                page: page,
                sort: this.sort,
                startDate: this.formatApiDate(this.startDateModel),
                endDate: this.formatApiDate(this.endDateModel),
                shop: this.shopsModel.id,
                status: this.statusModel.value,
                ticketSerial: this.ticketSerial,
                ticketType: this.ticketType,
                lotteryCode: this.lotteryModel.code,
                fixtureId: this.selectedDrawId,
                payShop: this.payShopsModel._id,
            };
            this.BoTicketsApi.getTickets(params)
                .then((response) => {
                    if (this.notNullOrEmptyObject(response.data)) {
                        this.items = response.data.data;
                        this.totalPages = response.data.total;
                    }

                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.checkForUnauthorizedError(error);
                });
        },
    },
};
</script>